window.renderFilms = [];
window.genres = [];
window.pageNumber = 1;
window.inputVaue ='';
window.selectFilm = {};

// let genres = [];